module.exports = __webpack_public_path__ + "static/media/boy-child-childhood-6459.d3e29db3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/boy-child-childhood-6459.jpg
// module id = 89
// module chunks = 0